import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {EventService, GlobalMessageService, GlobalMessageType, SiteContextActions, withdrawOn} from '@spartacus/core';
import {from, Observable} from 'rxjs';
import {catchError, concatMap, map} from 'rxjs/operators';
import {GonvarriQuoteEditEntry, QUOTE_EDIT_SPECIAL_REQUESTS} from "../actions/gonvarri-quote-edit.entry";
import {GonvarriQuoteAdapter} from "../adapters/gonvarri-quote.adapter";
import {CartActions} from "@spartacus/cart/base/core";
import {GonvarriResetActions} from "../actions/gonvarri-reset-actions";
import {QuoteDetailsReloadQueryEvent} from "@spartacus/quote/core";

@Injectable()
export class GonvarriQuoteEntryEffects {

  constructor(
    private actions$: Actions,
    private quoteAdapter: GonvarriQuoteAdapter,
    private globalMessageService: GlobalMessageService,
    private events: EventService
  ) {}

  private contextChange$ = this.actions$.pipe(
    ofType(
      SiteContextActions.CURRENCY_CHANGE,
      SiteContextActions.LANGUAGE_CHANGE
    )
  );

  editEntry$: Observable<
    | GonvarriQuoteEditEntry
    | CartActions.LoadCart
    | CartActions.CartUpdateEntrySuccess
    | GonvarriResetActions
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(QUOTE_EDIT_SPECIAL_REQUESTS),
      map((action: GonvarriQuoteEditEntry) => action.payload),
      concatMap((payload) =>
        this.quoteAdapter.editQuoteDiscount(
          payload.entryNumber,
          payload.quoteCode,
          payload.discount,
          payload.userId
        )
          .pipe(
            map(() => {
              this.events.dispatch(new QuoteDetailsReloadQueryEvent());
              let action: any = new GonvarriResetActions();
              return action;
            }),
            catchError((error) => {
              this.globalMessageService.add(error.error?.errors[0].message, GlobalMessageType.MSG_TYPE_ERROR);
              return from([
                new GonvarriResetActions()
              ]);
            })
          )
      ),
      withdrawOn(this.contextChange$),
    )
  );

}
